import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { SvgEyeOff, Icon } from '@tmapy/style-guide';

const msg = defineMessages({
  tooltip: {
    id: 'publishset.adminOnlyIcon.tooltip',
    defaultMessage: 'Neveřejná sada – vidí a objedná ji pouze administrátor.',
  },
});

export const AdminOnlyIcon: React.FC = () => {
  const intl = useIntl();
  return (
    <span className='sg-a-d-f sg-u-c-body-darkest'>
      <Icon element={<SvgEyeOff />} tooltip={intl.formatMessage(msg.tooltip)} />
    </span>
  );
};
